module.exports = __webpack_public_path__ + "static/media/persona-volkan.834e623c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/persona-volkan.svg
// module id = 48
// module chunks = 0